<template>
  <!-- Chat Box -->
  <div
    data-sidebar-content="chat"
    class="chat-content-wrap"
    id="data-sidebar-content"
  >
    <div class="d-flex pl-3 pr-3 pt-2 pb-2 o-hidden box-shadow-1 chat-topbar">
      <a data-sidebar-toggle="chat" class="link-icon d-md-none">
        <i class="icon-regular i-Right ml-0 mr-3"></i>
      </a>
      <!-- Title Name -->
      <div class="d-flex align-items-center">
        <p class="m-0 text-title text-16 flex-grow-1">
          {{ selected_conversation.customer.username }}
        </p>
      </div>
    </div>
    <div
      class="chat-content perfect-scrollbar"
      data-suppress-scroll-x="true"
      id="chat-content-box"
      ref="chatbox"
    >
      <loading
        :active.sync="isLoading"
        can-cancel="true"
        is-full-page="true"
        heigh="1000px"
        width="1000px"
      ></loading>
      <div v-if="!isLoading">
        <div
          class="d-flex mb-4"
          v-for="(message, index) in messages"
          :key="index"
        >
          <div class="message flex-grow-1">
            <div class="d-flex">
              <p
                class="mb-1 text-title text-16 flex-grow-1"
                v-if="!message.is_sender"
              >
                {{ message.participant.username }}
              </p>
              <p
                class="mb-1 text-title text-16 flex-grow-1 nav-text"
                v-if="message.is_sender"
              >
                You
              </p>
              <span class="text-small text-muted">{{
                message.created_at
              }}</span>
            </div>
            <p class="m-0">{{ message.body }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pl-3 pr-3 pt-3 pb-3 box-shadow-1 chat-input-area">
      <div class="inputForm">
        <div class="form-group">
          <textarea
            class="form-control form-control-rounded"
            placeholder="Type your message"
            name="message"
            id="message"
            cols="30"
            rows="3"
            v-model="chat.message"
            v-on:keyup.enter="submitChatMessage"
            :disabled="!conversation"
          ></textarea>
        </div>
        <div class="d-flex">
          <div class="flex-grow-1"></div>
          <!-- Send Button -->
          <button class="btn btn-primary text-white" @click="submitChatMessage">
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PerfectScrollbar from "perfect-scrollbar";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "chat-content",
  components: { Loading },
  props: ["conversation"],
  data() {
    return {
      isLoading: true,
      selected_conversation: {
        customer: {
          username: ""
        }
      },
      chatInterval: null,
      messages: [],
      chat: {
        message: ""
      }
    };
  },

  methods: {
    loadChatContent() {
      const ps = new PerfectScrollbar("#chat-content-box");
    },
    loadChatView() {
      // Functions for Chat // Copied from 'public/assets/js/sidebar.script.js'
      var s = $("[data-sidebar-container]").addClass("sidebar-container");
      $("[data-sidebar-content]").addClass("sidebar-content"),
        $("[data-sidebar]").addClass("sidebar");
      s.each(function(s) {
        var i,
          t,
          a,
          l,
          e,
          r,
          n = $(this);

        function c() {
          (i = n.data("sidebar-container")),
            (t = $('[data-sidebar-content="' + i + '"]')),
            (a = $('[data-sidebar="' + i + '"]')),
            (l = $('[data-sidebar-toggle="' + i + '"]')),
            (e = a.outerWidth()),
            "right" === (r = a.data("sidebar-position"))
              ? (gullUtils.isMobile()
                  ? t.css("margin-right", 0)
                  : t.css("margin-right", e),
                gullUtils.isMobile() ? a.css("right", -e) : a.css("right", 0))
              : (gullUtils.isMobile()
                  ? t.css("margin-left", 0)
                  : t.css("margin-left", e),
                gullUtils.isMobile() ? a.css("left", -e) : a.css("left", 0));
        }
        c(),
          $(window).on("resize", function(s) {
            setTimeout(function() {
              c();
            }, 300);
          }),
          l.on("click", function(s) {
            "right" === r
              ? "0px" == a.css("right")
                ? (a.css("right", -e),
                  !gullUtils.isMobile() && t.css("margin-right", 0))
                : (a.css("right", 0),
                  !gullUtils.isMobile() && t.css("margin-right", e))
              : "0px" == a.css("left")
              ? (a.css("left", -e),
                !gullUtils.isMobile() && t.css("margin-left", 0))
              : (a.css("left", 0),
                !gullUtils.isMobile() && t.css("margin-left", e));
          });
      });
    },
    async loadMessages() {
      clearInterval(this.chatInterval);
      console.log("test");
      let token = localStorage.getItem("token");

      if (token === null || !this.$props.conversation) {
        return false;
      }

      this.selected_conversation = this.$props.conversation;

      token = JSON.parse(token);
      token = token.access_token;

      const header = { headers: { Authorization: "Bearer " + token } };

      const url = `/chat/conversations/${this.$props.conversation.id}/messages`;
      const { data } = await axios.get(url, header);
      this.messages = data.data;
      this.scrollToEnd();

      

      // poll the server to get the lastest chat
      this.chatInterval = setInterval(async () => {
        const { data } = await axios.get(url, header);
        const current_last_message_id = this.messages[this.messages.length - 1]
          .id;
        const data_last_message = data.data[data.data.length - 1];
        const data_last_message_id = data_last_message.id;


        // play sound if the polled lastest chat id is not the same as the last chat id in vue data
        if (
          current_last_message_id !== data_last_message_id &&
          data_last_message.is_sender === 0
        ) {

          const audio = new Audio(require("@/assets/sounds/chat.mp3"));
          audio.play();
          // set the messages
        }
        this.messages = data.data;
        this.scrollToEnd();
      }, 5 * 1000); // poll every 5 seconds
    },

    async submitChatMessage() {
      let token = localStorage.getItem("token");

      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      const header = { headers: { Authorization: "Bearer " + token } };

      const url = `/chat/conversations/${this.$props.conversation.id}/messages`;

      const { data } = await axios.post(url, this.chat, header);

      this.chat.message = "";

      this.loadMessages();
    },

    scrollToEnd() {
      setTimeout(() => {
        this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
        this.isLoading = false;
      }, 0);
    }
  },
  watch: {
    conversation: {
      handler: function(newVal, oldVal) {
        this.isLoading = true;
        // clearInterval(this.chatInterval);
        this.loadMessages();
        this.selected_conversation = this.$props.conversation;
      },
      deep: true
    }
  },

  mounted() {
    this.isLoading = true;
    this.loadChatView();
    this.loadChatContent();
    this.loadMessages();
    this.isLoading = false;
  },

  beforeDestroy() {
    clearInterval(this.chatInterval);
  }
};
</script>
